// Filename - "./components/nav.js
 
import "../styles/Nav.css";
import React from "react";
import { Nav, NavLink, NavMenu } from "./navBarElements";


const MyNav = () => {
  return (
    <>
      <Nav class="topnav" id="myTopnav">
        <NavMenu>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/blog">Blog</NavLink>
          <NavLink to="/photography">Photography</NavLink>
          <NavLink to="/contact">Contact Us</NavLink>
        </NavMenu>
      </Nav>
    </>
  );
};

export default MyNav;